export default __webpack_public_path__ + "static/media/Content3.f1aadef9.png";